import type { CertificationLogo } from '../types';

export const certifications: CertificationLogo[] = [
  {
    id: 'ema',
    name: 'Entidad Mexicana de Acreditación MM',
    logo: '/Logotipo_ema_V1.svg',
    alt: 'Logo de Entidad Mexicana de Acreditación (EMA)',
    link: 'https://www.ema.org.mx',
    pdfUrl: '/certifications/ACREDITACIÓN METAL MECÁNICA VIGENTE.pdf',
  },
    {
    id: 'ema2',
    name: 'Entidad Mexicana de Acreditación C',
    logo: '/Logotipo_ema_V2.svg',
    alt: 'Logo de EMA2',
    link: 'https://www.ema.org.mx',
    pdfUrl: '/certifications/ACREDITACIÓN CONSTRUCCIÓN VIGENTE.pdf',
  },
  {
    id: 'ema3',
    name: 'Entidad Mexicana de Acreditación Q',
    logo: '/Logotipo_emaV3.svg',
    alt: 'Logo de Entidad Mexicana de Acreditación (EMA)',
    link: 'https://www.ema.org.mx',
    pdfUrl: '/certifications/ACREDITACIÓN QUÍMICA VIGENTE.pdf',
  },
  {
    id: 'ema4',
    name: 'Entidad Mexicana de Acreditación TV',
    logo: '/Logotipo_ema_V4.svg',
    alt: 'Logo de Entidad Mexicana de Acreditación (EMA)',
    link: 'https://www.ema.org.mx',
    pdfUrl: '/certifications/ACREDITACIÓN TEXTIL Y DEL VESTIDO VIGENTE.pdf',
  },

  {
    id: 'aci',
    name: 'Instituto Americano del Concreto',
    logo: '/Logotipo_ACI.svg',
    alt: 'Logo de ACI',
    link: 'https://acimexico-centro.org/',
    pdfUrl: '/certifications/SOCIO ACI 2026.pdf',
  },
  {
    id: 'analisec',
    name: 'Asociación Nacional de Laoratorios Independientes al Servicio de la Construcción A.C.',
    logo: '/Logotipo_Analisec.svg',
    alt: 'Logo de Analisec',
    link: 'https://www.analisec.com.mx/',
    pdfUrl: '/certifications/SOCIO ANALISEC 2026.pdf',
  },
  {
    id: 'amaac',
    name: 'Asociación Mexicana Del Asfalto, A.C.',
    logo: '/Logotipo_AMAAC.svg',
    alt: 'Logo de AMAAC',
    link: 'Asociación Mexicana Del Asfalto, A.C.',
    pdfUrl: '/certifications/SOCIO AMAAC 2026.pdf',
  },
  {
    id: 'anippac',
    name: 'Asociación Nacional de Industriales del Presfuerzo y la Prefabricación A.C.',
    logo: '/Logotipo_ANIPPAC.svg',
    alt: 'Logo de ANIPPAC',
    link: 'https://anippac.org.mx/',
    pdfUrl: '/certifications/CERTIFICADO ANIPPAC 2025.pdf',
  },
];